var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as t from 'io-ts';
import * as Errors from "../../errors/errorMessages";
import { FetchError } from "../../errors/errorTypes";
import { CredentialStatus, EgressResponse, isContext, isExtensionConfigurationValue, SerializableRecord, UserProvidedFetchConfig, UserProvidedPredefinedRequest, UserProvidedQualtricsApiFetchConfig, } from "../../models";
import { isPresent, NonEmptyString, OptionalArg } from "../../modelUtils";
import MessageChannel from "../messages/messageChannel";
import { getClientVersion } from "./buildConfig";
import { PluginClientHandlerCollection } from "./models";
import Translator from './translations';
var referrer = document.referrer ? new URL(document.referrer).origin : null;
window.Promise = window.Promise || Promise;
var LONG_TIMEOUT = 10000;
var INIT_EVENT = 'init';
var PluginClient = /** @class */ (function () {
    function PluginClient(context, channel) {
        var _this = this;
        this.context = context;
        this.channel = channel;
        this.onCredentialStatusChange = function (callback) {
            var fetchInitialStatus = function () { return __awaiter(_this, void 0, void 0, function () {
                var status;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.isCredentialSelected()];
                        case 1:
                            status = _a.sent();
                            return [2 /*return*/, {
                                    isCredentialSelected: status,
                                    credentialStatus: CredentialStatus.INITIALIZED,
                                    connections: this.context.connections,
                                }];
                    }
                });
            }); };
            var initializeOnCredentialStatusChange = function () { return __awaiter(_this, void 0, void 0, function () {
                var initialData, _a, handleMessage;
                var _this = this;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, fetchInitialStatus()];
                        case 1:
                            initialData = _b.sent();
                            callback(initialData);
                            return [3 /*break*/, 3];
                        case 2:
                            _a = _b.sent();
                            throw new Error('Error fetching initial credential status');
                        case 3:
                            handleMessage = function (message) {
                                if (typeof message !== 'object' || !message)
                                    return;
                                if (!('isCredentialSelected' in message) || !('credentialStatus' in message))
                                    return;
                                callback(message);
                            };
                            this.channel.registerHandler('useCredentials', handleMessage);
                            return [2 /*return*/, function () {
                                    _this.channel.removeHandler('useCredentials');
                                }];
                    }
                });
            }); };
            initializeOnCredentialStatusChange().catch(function () { });
        };
        if (this.context.translations) {
            this.translator = new Translator(this.context.translations);
        }
    }
    // Factory method. Fetches context before constructing and returning the plugin client.
    PluginClient.initialize = function () {
        return __awaiter(this, arguments, void 0, function (handlers) {
            var channel, initMessage, maybeContext, context, pluginClient, getWrappedHandler, _i, _a, name_1;
            if (handlers === void 0) { handlers = {}; }
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!PluginClientHandlerCollection.is(handlers)) {
                            throw Errors.invalidParameter('handlers', 'Must be a collection of functions');
                        }
                        channel = new MessageChannel({
                            name: 'plugin',
                            other: window.parent,
                            otherOrigin: referrer,
                        });
                        initMessage = { clientVersion: getClientVersion() };
                        return [4 /*yield*/, channel.postMessage(INIT_EVENT, initMessage)];
                    case 1:
                        maybeContext = _b.sent();
                        if (!isContext(maybeContext)) {
                            throw new Error("init message replied with an invalid context: ".concat(typeof maybeContext === 'object' && maybeContext
                                ? JSON.stringify(maybeContext)
                                : typeof maybeContext));
                        }
                        context = maybeContext;
                        channel.setInstanceId(context.instanceID);
                        pluginClient = new PluginClient(context, channel);
                        getWrappedHandler = function (handler, pluginClient) {
                            return function (data) { return handler(data, pluginClient); };
                        };
                        // wrap each of the provided handlers and register them to the channel
                        for (_i = 0, _a = Object.getOwnPropertyNames(handlers); _i < _a.length; _i++) {
                            name_1 = _a[_i];
                            channel.registerHandler(name_1, getWrappedHandler(handlers[name_1], pluginClient));
                        }
                        return [2 /*return*/, pluginClient];
                }
            });
        });
    };
    PluginClient.prototype.destroy = function () {
        // Disconnect message channel
        if (this.channel) {
            this.channel.destroy();
        }
    };
    /*
      Generic post message to the parent window. Returns a promise to be resolved once the host replies.
    */
    PluginClient.prototype.postMessage = function (name, data, timeout) {
        if (timeout === void 0) { timeout = LONG_TIMEOUT; }
        return this.channel.postMessage(name, data, timeout);
    };
    /**
     * Sends a request to the provided URL. Injects user defined account for authentication
     * if specified in connection property.
     *
     * fetchConfig should be formatted as follows:
     * {
     *   method {string}: the http method to use (ex: 'POST', 'GET, 'PUT', etc.)
     *   headers {object} (optional): key/value pairs that correspond to headers to add to the request (ex: "Content-Type": "application/json")
     *   body {object | string} (optional): the body of the request
     *   params {object} (optional): key/value pairs that correspond query params to add to the request URL (ex: "filter": "random")
     *   connection {object} (optional): {
     *     connectionName {string}: the name of the connection to use (see context.availableConnections for a list of connections).
     *     paramFormat {string}: where to place the credential. Can be 'header','body', or 'query'.
     *     paramName {string}: what to name the credential param. As in, the field name for a body param, the query name for a query param, or the header name for a header. Ex: for a bearer token this might be "Authorization".
     *     paramTemplate {string}: what to insert the credential as. Use it similarly to a string passed to String.format. EX: "Bearer %s" would be a template for bearer tokens, "%s" inserts the token as-is.
     *   }
     * }
     * @param {string} url - The URL to make a request to
     * @param {object} fetchConfig - Configures all aspects of the request
     * @param {number} timeout - Defaults to 10000 (10 seconds). Specifies the number of milliseconds at which to reject the returned promise if no response has been received from the Plugin.
     * @returns {Promise} resolves to an object containing {responseBody: JSON string, httpStatusCode: string}
     */
    PluginClient.prototype.fetch = function (url_1, fetchConfig_1) {
        return __awaiter(this, arguments, void 0, function (url, fetchConfig, timeout) {
            var fetchMessage;
            if (timeout === void 0) { timeout = LONG_TIMEOUT; }
            return __generator(this, function (_a) {
                this.validateFetchInput(url, timeout);
                if (!isPresent(fetchConfig)) {
                    throw Errors.missingVariable('fetchConfig');
                }
                if (!UserProvidedFetchConfig.is(fetchConfig)) {
                    throw Errors.invalidInterface('fetchConfig', UserProvidedFetchConfig, fetchConfig);
                }
                fetchMessage = __assign(__assign({}, fetchConfig), { url: url });
                return [2 /*return*/, this.channel.postMessage('fetch', fetchMessage, timeout)];
            });
        });
    };
    /**
     * The exciting sequel to `fetch`
     *
     * Sends a request to the provided URL. Injects user defined account for authentication
     * if specified in connection property.
     *
     * fetchConfig should be formatted as follows:
     * {
     *   method {string}: the http method to use (ex: 'POST', 'GET, 'PUT', etc.)
     *   headers {object} (optional): key/value pairs that correspond to headers to add to the request (ex: "Content-Type": "application/json")
     *   body {object | string} (optional): the body of the request
     *   params {object} (optional): key/value pairs that correspond query params to add to the request URL (ex: "filter": "random")
     *   connection {object} (optional): {
     *     connectionName {string}: the name of the connection to use (see context.availableConnections for a list of connections).
     *     paramFormat {string}: where to place the credential. Can be 'header','body', or 'query'.
     *     paramName {string}: what to name the credential param. As in, the field name for a body param, the query name for a query param, or the header name for a header. Ex: for a bearer token this might be "Authorization".
     *     paramTemplate {string}: what to insert the credential as. Use it similarly to a string passed to String.format. EX: "Bearer %s" would be a template for bearer tokens, "%s" inserts the token as-is.
     *   }
     * }
     *
     * Support: Base64 File Upload (fetchInternal connections only)
     * When using an 'internal' connection with Content-Type: multipart/form-data, you can upload
     * a single base64-encoded file by structuring the body as:
     * {
     *   data: "base64EncodedFileData...",
     *   filename: "document.pdf",
     *   type: "application/pdf"
     * }
     * The plugin host will automatically decode the base64 data, calculate the file size, and create
     * a FormData with a single "file" field containing the decoded file.
     *
     * Promise resolves to either a successful FetchResponse or throws a FetchError. Both
     * contain a `status` prop for checking the status code and a `responseData` property that
     * contains whatever the response has. This could be more information on the Error that
     * occurred or the data that was requested.
     *
     * Successful response example:
     * {
     *  status: 200
     *  responseData: {
     *    ... // data from the 3rd party service
     *  }
     * }
     *
     * Error response Example:
     * Uncaught Error: "GET https://pokeapi.co/api/v2/pokemon/porkachu/ 404 Not Found"
     * {
     *  status: 404
     *  responseData: "404 - Not Found"
     * }
     *
     * @param {string} url - The URL to make a request to
     * @param {object} fetchConfig - Configures all aspects of the request
     * @param {number} timeout - Defaults to 10000 (10 seconds). Specifies the number of milliseconds at which to reject the returned promise if no response has been received from the Plugin.
     * @returns {Promise} response from the service
     */
    PluginClient.prototype.fetch2 = function (url_1, fetchConfig_1) {
        return __awaiter(this, arguments, void 0, function (url, fetchConfig, timeout) {
            var res;
            if (timeout === void 0) { timeout = LONG_TIMEOUT; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetch(url, fetchConfig, timeout)];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, this.formatEgressGatewayResponse(res)];
                }
            });
        });
    };
    /**
     * Invokes a named Predefined Request in Egress Gateway that is defined inside connection.
     *
     * The predefinedRequest should be formatted as follows:
     * {
     *   requestName {string}: the name of the Predefined Request to invoke
     *   connection {object} : {
     *     connectionName {string}: the name of the connection to use (see context.availableConnections for a list of connections).
     *   }
     *   params {object} (optional): key/value pairs that correspond will replace placeholders in the Predefined Request
     * }
     * @param {object} predefinedRequest - Configures all aspects of the request
     * @param {number} timeout - Defaults to 10000 (10 seconds). Specifies the number of milliseconds at which to reject the returned promise if no response has been received from the Plugin.
     * @returns {Promise} - response from the API
     */
    PluginClient.prototype.invokePredefinedRequest = function (predefinedRequest_1) {
        return __awaiter(this, arguments, void 0, function (predefinedRequest, timeout) {
            var invokePredefinedRequestMessage, response;
            if (timeout === void 0) { timeout = LONG_TIMEOUT; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!isPresent(predefinedRequest)) {
                            throw Errors.missingVariable('predefinedRequest');
                        }
                        if (!UserProvidedPredefinedRequest.is(predefinedRequest)) {
                            throw Errors.invalidInterface('predefinedRequest', UserProvidedPredefinedRequest, predefinedRequest);
                        }
                        invokePredefinedRequestMessage = __assign({}, predefinedRequest);
                        return [4 /*yield*/, this.channel.postMessage('invokePredefinedRequest', invokePredefinedRequestMessage, timeout)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.formatEgressGatewayResponse(response)];
                }
            });
        });
    };
    PluginClient.prototype.isCredentialSelected = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.context.availableConnections.length) {
                            return [2 /*return*/, false];
                        }
                        return [4 /*yield*/, this.channel.postMessage('isCredentialSelected')];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, !!response];
                }
            });
        });
    };
    /* credit: https://github.com/lodash/lodash/issues/2142 */
    PluginClient.prototype.isJSON = function (string) {
        try {
            var obj = JSON.parse(string);
            if (obj && typeof obj === 'object' && obj !== null) {
                return true;
            }
            // eslint-disable-next-line no-empty
        }
        catch (err) { }
        return false;
    };
    /**
     * Make a request to Qualtrics Public API. Similar to fetch, but doesn't accept a connection.
     *
     * The config should be formatted as follows:
     * {
     *   method {string}: the http method to use (ex: 'POST', 'GET, 'PUT', etc.)
     *   body {object | string} (optional): the body of the request
     * }
     * @param {string} url - The relative Qualtrics API path to make a request to, such as `surveys`
     * @param {object} config - Configures all aspects of the request
     * @param {number} timeout - Defaults to 10000 (10 seconds). Specifies the number of milliseconds at which to reject the returned promise if no response has been received from the Plugin.
     * @returns {Promise} - response from the API
     */
    PluginClient.prototype.qualtricsApiFetch = function (url_1, config_1) {
        return __awaiter(this, arguments, void 0, function (url, config, timeout) {
            var qualtricsApiFetchMessage, response;
            if (timeout === void 0) { timeout = LONG_TIMEOUT; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.validateFetchInput(url, timeout);
                        if (!isPresent(config)) {
                            throw Errors.missingVariable('config');
                        }
                        if (!UserProvidedQualtricsApiFetchConfig.is(config)) {
                            throw Errors.invalidInterface('config', UserProvidedQualtricsApiFetchConfig, config);
                        }
                        url = this.removeLeadingSlash(url);
                        qualtricsApiFetchMessage = __assign(__assign({}, config), { url: url });
                        return [4 /*yield*/, this.channel.postMessage('apiv3', qualtricsApiFetchMessage, timeout)];
                    case 1:
                        response = _a.sent();
                        if (!SerializableRecord.is(response)) {
                            throw new Error("Response From API v3 is not a record. Instead received ".concat(typeof response === 'object' && response ? JSON.stringify(response) : 'unknown type'));
                        }
                        return [2 /*return*/, response];
                }
            });
        });
    };
    /**
     * The exciting sequel to `qualtricsApiFetch`
     *
     * Make a request to Qualtrics Public API. Similar to fetch, but doesn't accept a connection.
     *
     * The config should be formatted as follows:
     * {
     *   method {string}: the http method to use (ex: 'POST', 'GET, 'PUT', etc.)
     *   body {object | string} (optional): the body of the request
     * }
     *
     * Promise resolves to either a successful FetchResponse or throws a FetchError. Both
     * contain a `status` prop for checking the status code and a `responseData` property that
     * contains whatever the response has. This could be more information on the Error that
     * occurred or the data that was requested.
     *
     * Successful response example:
     * {
     *  status: 200
     *  responseData: {
     *    meta: {
     *      httpStatus: "200 - OK"
     *      requestId: "c0bf74f9-7119-47c1-99bf-3d2353032d11"
     *    }
     *    result: {
     *      elements: [...] //surveys
     *      nextPage: null
     *    }
     *  }
     * }
     *
     * Error response Example:
     * Uncaught Error: "GET /API/v3/surveys/SV_notarealid 400 Bad Request"
     * {
     *  status: 400
     *  responseData: {
     *    meta: {
     *      httpStatus: "400 - Bad Request"
     *      error: {
     *        errorMessage: "Invalid surveyId."
     *        errorCode: "GSI_1"
     *      }
     *    }
     *    requestId: "41885efc-4ecf-41db-890b-9e3d5222112a"
     *    }
     *  }
     * }
     * @param {string} url - The relative Qualtrics API path to make a request to, such as `surveys`
     * @param {object} config - Configures all aspects of the request
     * @param {number} timeout - Defaults to 10000 (10 seconds). Specifies the number of milliseconds at which to reject the returned promise if no response has been received from the Plugin.
     * @returns {Promise} - response from the API.
     */
    PluginClient.prototype.qualtricsApiFetch2 = function (url_1, config_1) {
        return __awaiter(this, arguments, void 0, function (url, config, timeout) {
            var res, status, statusText, errorMessage, fetchResponse;
            if (timeout === void 0) { timeout = LONG_TIMEOUT; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.qualtricsApiFetch(url, config, timeout)
                        // required typeguard to appease TS
                    ];
                    case 1:
                        res = _a.sent();
                        // required typeguard to appease TS
                        if (!(res === null || res === void 0 ? void 0 : res.status) || !(typeof (res === null || res === void 0 ? void 0 : res.status) === 'number')) {
                            throw new Error('Fetch response received is missing a status code.');
                        }
                        status = res.status;
                        // if there's an error on the request, the messageChannel promise won't reject, so it
                        // has to be manually checked for and thrown here
                        if (status > 299 || status < 200) {
                            statusText = void 0;
                            if (res.statusText && typeof res.statusText === 'string') {
                                statusText = res.statusText;
                            }
                            else {
                                statusText = 'Unknown status';
                            }
                            errorMessage = "".concat(config.method, " /API/v3/").concat(url, " ").concat(status, " ").concat(statusText);
                            throw new FetchError(errorMessage, status, res.data);
                        }
                        fetchResponse = {
                            status: res.status,
                            responseData: res.data,
                        };
                        return [2 /*return*/, fetchResponse];
                }
            });
        });
    };
    PluginClient.prototype.logAmplitudeEvent = function (eventNamespace_1, eventName_1) {
        return __awaiter(this, arguments, void 0, function (eventNamespace, eventName, eventData, groups) {
            if (eventData === void 0) { eventData = {}; }
            return __generator(this, function (_a) {
                return [2 /*return*/, this.channel.postMessage('logAmplitudeEvent', {
                        eventNamespace: eventNamespace,
                        eventName: eventName,
                        eventData: eventData,
                        groups: groups,
                    }, LONG_TIMEOUT)];
            });
        });
    };
    /*
      Formats the response from Egress Gateway to be consistent with the FetchResponse type.
     */
    PluginClient.prototype.formatEgressGatewayResponse = function (res) {
        if (!EgressResponse.is(res)) {
            throw new Error("Response received is not an Egress Response. Instead received ".concat(typeof res));
        }
        // error throwing done by Plugin Manager, so just formatting here
        var fetchResponse = {
            status: res.httpStatusCode,
            responseData: this.isJSON(res.responseBody) ? JSON.parse(res.responseBody) : res.responseBody,
            responseHeaders: res.responseHeaders,
        };
        return fetchResponse;
    };
    /*
      Validates expectations for the input to the fetch functions. Throws an error if any issues are detected.
      Accepts isApiFetch to modify checks for qualtricsApiFetch; defaults to false.
    */
    PluginClient.prototype.validateFetchInput = function (url, timeout) {
        if (!isPresent(url)) {
            throw Errors.missingVariable('url');
        }
        if (!NonEmptyString.is(url)) {
            throw Errors.invalidParameter('url', 'Must be a non-empty string');
        }
        if (!t.number.is(timeout)) {
            throw Errors.invalidParameter('timeout', 'Must be an integer');
        }
    };
    PluginClient.prototype.removeLeadingSlash = function (url) {
        if (url.startsWith('/')) {
            return url.substring(1);
        }
        return url;
    };
    /*
      Returns the context object that was given by the host on init.
    */
    PluginClient.prototype.getContext = function () {
        return this.context;
    };
    /*
      Returns the value of the config with the given name.
    */
    PluginClient.prototype.getConfig = function (configName) {
        return __awaiter(this, void 0, void 0, function () {
            var config;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.channel.postMessage('getConfig', { name: configName })];
                    case 1:
                        config = _a.sent();
                        if (!isExtensionConfigurationValue(config)) {
                            throw new Error('Config is not an ExtensionConfigurationValue');
                        }
                        return [2 /*return*/, config];
                }
            });
        });
    };
    /*
      Returns the language code of the logged in user given by the host on init.
    */
    PluginClient.prototype.getLanguage = function () {
        return this.context.language;
    };
    PluginClient.prototype.getText = function (key, placeHolders, defaultVal) {
        if (!isPresent(key)) {
            throw Errors.missingVariable('key');
        }
        if (!NonEmptyString.is(key)) {
            throw Errors.invalidParameter('key', 'Must be a non-empty string');
        }
        if (!OptionalArg(t.record(t.string, t.string)).is(placeHolders)) {
            throw Errors.invalidParameter('placeHolders', 'Must be a collection of strings if present');
        }
        if (!OptionalArg(NonEmptyString).is(defaultVal)) {
            throw Errors.invalidParameter('defaultValue', 'Must be non-empty string if provided');
        }
        if (!this.translator) {
            throw new Error('Translation file not found');
        }
        return this.translator.getText(key, placeHolders, defaultVal);
    };
    return PluginClient;
}());
export default PluginClient;
//# sourceMappingURL=pluginClient.js.map